import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import SidebarLayout from '../components/SidebarLayout'

function AnnouncementsPage() {
  const [announcements, setAnnouncements] = useState([])

  useEffect(() => {
    const fetchAll = async () => {
      const { data, error } = await supabase
        .from('announcements')
        .select('title, message, created_at')
        .order('created_at', { ascending: false })

      if (!error) setAnnouncements(data || [])
    }

    fetchAll()
  }, [])

  return (
    <SidebarLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div
          style={{
            backgroundColor: '#f1f5f9', // slate-100
            padding: '1rem 1.25rem',
            borderBottom: '1px solid #e2e8f0', // gray-200
            fontSize: '1.125rem', // text-lg
            fontWeight: 600,      // font-semibold
            color: '#0f172a',     // slate-900
            borderTopLeftRadius: '0.5rem',
            borderTopRightRadius: '0.5rem',
            textAlign: 'center'   // ⬅️ Center the text
            }}
        >
          Official Announcements
        </div>

        {announcements.length === 0 ? (
          <p>No announcements found.</p>
        ) : (
          announcements.map((a, idx) => (
            <div
              key={idx}
              style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '1rem',
                marginBottom: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.03)',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#111827' }}>
                {a.title}
              </h3>
              <p style={{ marginTop: '0.25rem', color: '#6b7280', fontSize: '0.8rem' }}>
                {new Date(a.created_at).toLocaleDateString()}
              </p>
              <p style={{ marginTop: '0.5rem', color: '#374151' }}>{a.message}</p>
            </div>
          ))
        )}
      </div>
    </SidebarLayout>
  )
}

export default AnnouncementsPage
